import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../mock';

export default function Testimonials() {
  // duplicate for infinite scroll
  const doubled = [...testimonials, ...testimonials];
  return (
    <section id="testimonials" className="section bg-white overflow-hidden">
      <div className="container-x text-center mb-10">
        <div className="eyebrow">Testimonials</div>
        <h2 className="section-title mt-3">Loved by Growing Brands</h2>
        <p className="section-sub mt-4 mx-auto">
          Real stories from real merchants who scaled their business with EC Safetrade Solutions.
        </p>
      </div>

      <div className="relative no-scrollbar">
        <div className="flex gap-6 marquee-track w-max">
          {doubled.map((t, i) => (
            <div
              key={i}
              className="w-[340px] shrink-0 bg-gradient-to-br from-white to-[color:var(--brand-green-light)]/40 rounded-2xl p-6 border border-neutral-100 shadow-sm"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: t.rating }).map((_, k) => (
                  <Star key={k} size={16} fill="#FFB629" stroke="#FFB629" />
                ))}
              </div>
              <Quote size={22} className="text-[color:var(--brand-green)] mb-2" />
              <p className="text-sm text-[color:var(--ink)] leading-relaxed">“{t.text}”</p>
              <div className="mt-5 pt-4 border-t border-neutral-100 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[color:var(--brand-green)] text-white font-bold flex items-center justify-center">
                  {t.name.split(' ').map((n) => n[0]).join('').slice(0, 2)}
                </div>
                <div>
                  <div className="font-bold text-sm text-[color:var(--ink)]">{t.name}</div>
                  <div className="text-xs text-[color:var(--ink-soft)]">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
